/* Built In Imports */

/* External Imports */
import { Link } from '@chakra-ui/next-js';
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import config from '@config';

/* Styles */
/* Services */

/**
 * return Blog Image Curtesy
 * @param sectionContent
 * @returns {ReactElement} - Blog Image Curtesy
 */
const BlogImageCurtesy = ({ sectionContent, lang }) => {
  // console.log('sectionContent', sectionContent);

  return (
    <Box width="100%" mx="auto">
      <Box
        background={`url(${config.imgPath}/d/46272/1663674009-camera.svg) no-repeat`}
        backgroundPosition="left"
        paddingLeft="28px"
        lineHeight="25px"
        fontFamily="var(--FedraSansStd-book)"
      >
        <Link
          color="#4D8ACC"
          textDecoration="underline"
          fontFamily="var(--FedraSerifDisplay-Regular)"
          fontSize="italic"
          href={sectionContent?.link}
          mr="5px"
          prefetch
        >
          {sectionContent?.linkText}
        </Link>
        {sectionContent?.title}
      </Box>
    </Box>
  );
};

export default BlogImageCurtesy;
